import OurSourcesDrawerDialog from '../our-sources/our-sources-drawer-dialog';
import SalesPitchTextContainer from './sales-pitch-text-container';
import { Button } from '@/shadcn-ui/button';

export default function VehicleDetailsSalesPitch() {
  const trigger = (
    <Button
      variant="clear"
      className="body2 inline h-auto border-b border-dashed border-flexcar-neutral50 text-flexcar-neutral50 hover:border-flexcar-neutral10 hover:text-flexcar-neutral10"
    >
      View Sources
    </Button>
  );
  return (
    <SalesPitchTextContainer
      isOnPDP={true}
      showSavings={false}
      showSavingsCalculatorV2={false}
    >
      <p className="body2 inline">Members typically save </p>
      <p className="body2-strong inline">90% upfront</p>
      <p className="body2 inline"> and </p>
      <p className="body2-strong inline">20% on monthly payments</p>
      <p className="body2 inline"> compared to traditional car loans.</p>
      {' ' /** Single space before 'View sources' text */}
      <OurSourcesDrawerDialog trigger={trigger} />
    </SalesPitchTextContainer>
  );
}
